import { forwardRef, useEffect, useState, useRef } from "react"
import { SDrawerOrModal, SGeneralForms, SFormImagesList, SFormUploadImage } from "shj-components"
import {message} from 'antd'
import {baseURL} from "@/api";
import { findOrderAccountDtlResponseByOrderIdRequest, whiteConfigFindResponseListByPage,
   startReceiptWhiteApplyProcess, whiteApplyFindDetailResponseByRequest } from "@/services/fmsConfig";
import { httpDictServTenant } from '@/services/fmsServices'
const ApproverChange = forwardRef((props: any, ref) => {
  const { title="收款白名单审批", open, onClose, orderId, id, record, reload, }: any = props
  const formRef = useRef<any>()
  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setLoading] = useState(false);
  const [reasonTypeName, setReasonTypeName] = useState('');
  const [fileList, setFileList] = useState([] as Array<any>)
  const uploadFileUrl = baseURL + `file-web/file/upload`;
  useEffect(() => {
    if(formRef && formRef.current){
      formRef.current?.onFormRef().resetFields()
    }
    if(orderId && open){
      init()
    }
    if(id && open){
      onView()
    }
    //
  },[open])
  const init = () =>{
    setLoading(true)
    findOrderAccountDtlResponseByOrderIdRequest({ orderId }).then(res => {
      formRef.current?.onFormRef().setFieldsValue({...res})
      setLoading(false)
    })
  }
  // 查看
  const onView = () => {
    setLoading(true)
    whiteApplyFindDetailResponseByRequest({ id }).then(res => {
      formRef.current?.onFormRef().setFieldsValue({
        whiteType: res?.whiteType,
        node: res?.nodeNameList?.join(','),
        whiteList: res?.receiptTypeNameList?.join(','),
        reasonType: res?.reasonType,
        remarks: res?.remarks,
      })
      setReasonTypeName(res?.reasonType || '')
      setLoading(false)
      setFileList(formatViewData(res?.fileInfoResponseList || []))
    })
  }
  const formatViewData = (urls: Array<any>) => {
    return urls.map(item => ({
      uid: item.id,  // 确保有唯一标识
      status: 'done',  // 标记为已完成上传状态
      url: item.absoluteFileUrl || item.fileUrl || item.url,  // 优先使用fileUrl，没有则用原有的url
      name: item.fileName || item.name,  // 优先使用fileName，没有则用原有的name
      response: item,  // 保留原始数据
      ...item  // 保留其他所有属性
    }))
  }
  const onSubmit = () => {
    formRef.current
      ?.onFormRef()
      .validateFields()
      .then(values => {
        setLoading(true);
        startReceiptWhiteApplyProcess({
          ...values,
          orderId: orderId,
        }).then(res => {
          message.success(res?.message || '操作成功')
          reload?.();
          onClose?.(true);
          setLoading(false);
        }).catch(err => {
          setLoading(false);
        })
      })
  };
  const getOptions = async() => {
    let whiteTypeList = await httpDictServTenant({ parentKey: 'whiteType', enabled: 1 })//类型
    let whiteReasonList = await httpDictServTenant({ parentKey: 'whiteReason', enabled: 1 })//原因
    return new Promise((resolve) => {
      resolve({
        whiteTypeList,
        whiteReasonList,
      });
    });
  };
  const formatUploadData = (urls: Array<any>) => {
    return urls.map(item => ({
      url: item.response ? item.response?.data?.fileUrl : item.url,
      name: item.response ? item.response?.data?.originalFilename : item.name,
      fileName: item.response ? item.response?.data?.originalFilename : item.name,
      fileUrl: item.response ? item.response?.data?.filePath : item.fileUrl
    }))
  }
  return (
    <SDrawerOrModal
      mode="drawer"
      title={title}
      open={open}
      okText="提交"
      onCancel={() => { onClose() }}
      onOk={onSubmit}
      loading={loading}
      width={800}
      okBtnDisabled={id? true : false}
    >
      <SGeneralForms
        ref={formRef}
        isHideGobackBtn={true}
        httpOptionsFn={getOptions}
        layout={id?'horizontal':'vertical'}
        isDetail={id? true : false}
        configs={[
          {
            title: '',
            formItem: [
              {
                name: 'whiteType',
                label: '类型',
                required: true,
                spanCol: 24,
                data: 'whiteTypeList',
                type: 'select',
                comConfig: {
                  fieldNames: { value: 'priKey', label: 'name' },
                  onChange: (value) => {
                    whiteConfigFindResponseListByPage(1, 1000, {
                      whiteType: value,
                      enabled: true,
                    }).then(res => {
                      const { records } = res;
                      let nodeNameList = records[0]?.nodeNameList || [];
                      let receiptTypeNameList = records[0]?.receiptTypeNameList || [];
                      formRef.current?.onFormRef().setFieldsValue({ node: nodeNameList.length > 0 ? nodeNameList.join(',') : '', whiteList: receiptTypeNameList.length > 0 ? receiptTypeNameList.join(',') : ''})
                    });
                  }
                },
              },
              {
                name: 'orderNo',
                label: '订单号',
                spanCol: 12,
                comConfig: {
                  disabled: true,
                }
              },
              {
                name: 'customerName',
                label: '客户信息',
                spanCol: 12,
                comConfig: {
                  disabled: true,
                }
              },
              {
                name: 'contractNo',
                label: '合同号',
                spanCol: 12,
                comConfig: {
                  disabled: true,
                }
              },
              {
                name: 'serviceAddressName',
                label: '服务地址',
                spanCol: 12,
                comConfig: {
                  disabled: true,
                }
              },
              {
                name: 'orderAmount',
                label: '订单金额',
                spanCol: 12,
                comConfig: {
                  disabled: true,
                }
              },
              {
                name: 'companyOrgName',
                label: '门店',
                spanCol: 12,
                comConfig: {
                  disabled: true,
                }
              },
              {
                name: 'node',
                label: '节点',
                spanCol: 12,
                isDeps: true,
                deps: [{ name: 'whiteType', value: true }],
                comConfig: {
                  disabled: true,
                }
              },
              {
                name: 'whiteList',
                label: '收款白名单',
                spanCol: 12,
                isDeps: true,
                deps: [{ name: 'whiteType', value: true }],
                comConfig: {
                  disabled: true,
                }
              },
              {
                name: 'bizTagName',
                label: '需求标签',
                spanCol: 12,
                isDetail: true,
              },
              {
                name: 'reasonType',
                label: '原因',
                required: true,
                spanCol: 24,
                data: 'whiteReasonList',
                type: 'select',
                comConfig: {
                  fieldNames: { value: 'priKey', label: 'name' },
                  onChange: (value) => {
                    setReasonTypeName(value)
                  }
                },
              },
              {
                name: 'remarks',
                label: '备注',
                required: true,
                spanCol: 24,
                type:'textarea',
              },
              {
                name: 'fileInfoList',
                label: reasonTypeName === 'whiteReasonLoanCust'?'附件（附件上传要求）':'附件',
                required: true,
                spanCol: 24,
                htmlFor: 'file',
                children: (
                  id ? <SFormImagesList imagesList={fileList || []} /> :
                  <SFormUploadImage
                    listType="picture"
                    url={uploadFileUrl}
                    setFileUrl={formatUploadData}
                  />
                ),
                tooltip: reasonTypeName === 'whiteReasonLoanCust' ? 
                <div>经办人需在流程中提交贷款客户完整的资料：<ol><li>客户贷款获批成功的凭证：客户成功接收银行贷款审批通过的手机短信通知或电脑屏幕截图(贷款审批通知书）（手机短信通知截图必须包含客户姓名、银行审批通过的下款金额、短信号码）</li><li>银行下发给客户的信用卡卡片照片（含卡号、持卡人姓名拼音）</li><li>贷款所属机构的名称（具体填写该银行的详细支行名称）、合作方的联系方式（手机、电话座机、工作名片）</li><li>若我司客户与银行贷款人非同一人，须提供关系证明文件进行佐证（如结婚证、户口本等）</li></ol></div>
                : null,
              },
            ]
          }]}
      />
    </SDrawerOrModal>
  )
})

export default ApproverChange
